
import YearRoutes from '@/modules/ReportCard/Year/router.js';
import TermsRoutes from '@/modules/ReportCard/Terms/router.js';
import CurriculumsRoutes from '@/modules/ReportCard/Curriculums/router.js';
import GradesRoutes from '@/modules/ReportCard/Grades/router.js';
import SubjectRoutes from '@/modules/ReportCard/Subject/router.js';
import TermCommentsRoutes from '@/modules/ReportCard/TermComments/router.js';
const Index = () => import(/* webpackChunkName: "expense" */ './index.vue');
// const List = () => import(/* webpackChunkName: "expense" */ './components/List.vue');
const Home = () => import(/* webpackChunkName: "expense" */ './view/Home.vue');

let routes = [];
routes = routes.concat(YearRoutes);
routes = routes.concat(TermsRoutes);
routes = routes.concat(GradesRoutes);
routes = routes.concat(CurriculumsRoutes);
routes = routes.concat(TermCommentsRoutes);
routes = routes.concat(SubjectRoutes);

routes = routes.concat([{
  path: 'home',
  name: 'reportcard-home',
  component: Home,
},
  // {
  //   path: 'list',
  //   name: 'expense-list',
  //   component: List,
  // },
]);

export default [{
  path: '/reportcard',
  redirect: { name: 'reportcard-home' },
  component: Index,
  children: routes,
}];
